import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";

const IMG =
  "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80";

const About = () => {
  const { t } = useLanguage();

  const stats = [
    { num: t.about.stat1Num, label: t.about.stat1Label },
    { num: t.about.stat2Num, label: t.about.stat2Label },
    { num: t.about.stat3Num, label: t.about.stat3Label },
  ];

  return (
    <section id="about" className="relative py-24 lg:py-36 bg-anthracite text-cream overflow-hidden">
      <div className="pointer-events-none absolute -top-32 right-0 w-[600px] h-[400px]" style={{ background: "radial-gradient(ellipse, rgba(198,156,34,0.12) 0%, transparent 60%)" }} />
      <div className="container-boe grid lg:grid-cols-2 gap-16 lg:gap-24 items-center relative">
        {/* Image side */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <div className="relative overflow-hidden rounded-3xl aspect-[4/5] shadow-2xl shadow-black/40 border border-gold/15">
            <img src={IMG} alt="Community hiking" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-anthracite/60 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-6 lg:-right-10 bg-anthracite-soft text-cream rounded-2xl px-6 py-5 shadow-2xl shadow-black/50 max-w-[240px] border border-gold/30">
            <span className="font-accent italic text-3xl text-gold leading-none" style={{ color: "#E5C76B" }}>"</span>
            <p className="text-sm leading-snug mt-1">
              Wir sind keine Veranstaltung. Wir sind eine Familie.
            </p>
            <p className="text-xs text-gold-soft mt-3" style={{ color: "#E5C76B" }}>— Alexei, Gründer</p>
          </div>
        </motion.div>

        {/* Text side */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <span className="section-eyebrow">{t.about.eyebrow}</span>
          <h2 className="mt-5 text-4xl md:text-5xl lg:text-[3.5rem] font-semibold text-cream leading-[1.05] tracking-tight">
            {t.about.title}
          </h2>
          <p className="mt-8 text-base md:text-lg text-cream/80 leading-relaxed">{t.about.p1}</p>
          <p className="mt-5 text-base md:text-lg text-cream/80 leading-relaxed">{t.about.p2}</p>
          <p className="mt-5 text-base md:text-lg font-accent italic leading-relaxed" style={{ color: "#E5C76B" }}>{t.about.p3}</p>

          <div className="mt-12 grid grid-cols-3 gap-4 pt-8 border-t border-cream/15">
            {stats.map((s, i) => (
              <div key={i}>
                <div className="text-3xl md:text-4xl font-semibold font-accent italic leading-none" style={{ color: "#E5C76B" }}>
                  {s.num}
                </div>
                <div className="mt-2 text-xs uppercase tracking-[0.15em] text-cream/60 font-medium">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
